const STORAGE_KEY = 'utm_tracking_parameters';

export default class UtmTrackingParameters {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;

  private constructor(params: Partial<UtmTrackingParameters>) {
    Object.assign(this, params);
  }

  static fromUrl(search: string): UtmTrackingParameters {
    const params = new URLSearchParams(search);

    return new UtmTrackingParameters({
      utm_source: params.get('utm_source') ?? undefined,
      utm_medium: params.get('utm_medium') ?? undefined,
      utm_campaign: params.get('utm_campaign') ?? undefined,
      utm_term: params.get('utm_term') ?? undefined,
      utm_content: params.get('utm_content') ?? undefined,
    });
  }
  static fromStorage(): UtmTrackingParameters | null {
    const storedUtmJson = localStorage.getItem(STORAGE_KEY);
    if (!storedUtmJson) {
      return null;
    }

    try {
      return new UtmTrackingParameters(JSON.parse(storedUtmJson));
    } catch {
      return null;
    }
  }

  static resolve(search: string): UtmTrackingParameters | null {
    const fromUrl = UtmTrackingParameters.fromUrl(search);

    if (fromUrl.hasAnyUtm()) {
      fromUrl.store();
      return fromUrl;
    }

    return UtmTrackingParameters.fromStorage();
  }

  hasAnyUtm(): boolean {
    return !!(this.utm_source || this.utm_medium || this.utm_campaign || this.utm_term || this.utm_content);
  }

  toQueryString(): string {
    const params = new URLSearchParams();

    if (this.utm_source) {
      params.set('utm_source', this.utm_source);
    }
    if (this.utm_medium) {
      params.set('utm_medium', this.utm_medium);
    }
    if (this.utm_campaign) {
      params.set('utm_campaign', this.utm_campaign);
    }
    if (this.utm_term) {
      params.set('utm_term', this.utm_term);
    }
    if (this.utm_content) {
      params.set('utm_content', this.utm_content);
    }

    return params.toString();
  }

  private store(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this));
  }
}
